/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Upload_Form_Fileid_Label2Inputs */

const en_pdf_upload_form_fileid_label2 = /** @type {(inputs: Pdf_Upload_Form_Fileid_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume (PDF)`)
};

const de_pdf_upload_form_fileid_label2 = /** @type {(inputs: Pdf_Upload_Form_Fileid_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf (PDF)`)
};

/**
* | output |
* | --- |
* | "Resume (PDF)" |
*
* @param {Pdf_Upload_Form_Fileid_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pdf_upload_form_fileid_label2 = /** @type {((inputs?: Pdf_Upload_Form_Fileid_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Upload_Form_Fileid_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_upload_form_fileid_label2(inputs)
	return en_pdf_upload_form_fileid_label2(inputs)
});
export { pdf_upload_form_fileid_label2 as "pdf_upload_form_fileID_label" }